<template>
    <div class="solution-info">
      <section class="solution-box">
         <el-carousel :interval="7200" direction="vertical" arrow="always" style="height: 100%;">
            <!-- <el-carousel-item v-for="item in src" :key="item"  style="height: 100%;">
              <el-image style="width: 100%; height: auto" :src="item" fit="contain"></el-image>
            </el-carousel-item> -->
            <el-carousel-item class="pro-item-box" style="background: #67C23Ab8">
              <h2 class="small">惠医服务</h2>
              <span class="pro-title">  云诊断中心 <br></span>
              <span>全网级影像调阅 <br></span>
              <span>医联体远程诊断与会诊 <br></span>
              <span>(专家诊断工作站) <br></span>
              <div class="pro-detail"><b>全网级影像调阅应用 ｜</b>基于H5方式的远程影像会诊/诊断，支持影像会诊报告的书写、发布、支持报告模板功能。会诊专家可以在任意位置、任何时间通过互联网安全认证进行远程影像会诊 。
通过远程诊断，让有限的医疗资源下沉到基层为医疗资源均质化，起到重要作用。<br></div>
                

            </el-carousel-item>
            <!-- <el-carousel-item :style="{backgroundImage:'url('+src2+')'}" style="background-size: 100% 100%"> -->
            <el-carousel-item class="pro-item-box bg-p-70">
              <h2 class="small">惠民服务</h2>
              <span>  数字胶片 <br></span>
                <span>电子报告/视频 <br></span>
                <span>在线查询 <br></span>
                <span>二维码分享</span>
              <div class="pro-detail"><b>云胶片应用 ｜</b> 就诊患者可以通过公众号、小程序、二维码及短信链接等入口方式，通过手机、PAD、电脑各种终端不限时间、不限地点地畅享数字影像查询、下载和分享等服务。支持DICOM、JPG、BMP、PNG等类型图像的显示，以及调窗、缩放、移动、旋转、测量、播放等常规DICOM图像处理功能。 <br><br></div>
            </el-carousel-item>
            <el-carousel-item class="pro-item-box" style="background: #409EFF">
              <h2 class="small">医联体数据中心</h2>
              <span>  物联网数据采集<br></span>
                <span>医联体数据共享交换统一治理 <br></span>
                <span>影像大数据集成平台</span>
              <div class="pro-detail"><b>医联体医学影像数据共享 ｜</b> 支持标准DICOM3.0接口医学信息技术，实现医联体内不同规模的医疗机构影像检查报告及DICOM影像互联互通可共享和交换、互查互访能互相调阅。构建区域医学影像共享平台，并在其上实现各种临床、教学、科研和管理的应用。 <br></div>
            </el-carousel-item>
            <el-carousel-item class="pro-item-box bg-o7-50">
              <h2 class="small">AI应用</h2>
                <span>CT 影像肺结节 <br></span>
                <span>云端计算、自动识别出 <br></span>
                <span>高效、快速、准确自动检测</span>
            </el-carousel-item>
          </el-carousel>
      </section>
    </div>
</template>
<script>
export default {
  name: "productInfo",
  data() {
    return {
    //   src1:  require('./images/ios_android.png'),
    // src2:  require('./images/film_compare.png'),
    };  
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.imgzoIndex .solution-info {
    height: 100%;
}
.imgzoIndex .solution-info .solution-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-bottom: 8px;
    background: #fff;
}
.imgzoIndex .solution-info .pro-item-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
  color: var(--WhiteColor-1);
}
.imgzoIndex .solution-info .pro-item-box .pro-detail {
    padding: 32px;
    box-sizing: border-box;
    line-height: 160%;
}

</style>